import React from 'react';

class FeedPostByline extends React.PureComponent {
  render() {
    let post = this.props.post;
    let subjectLine = this.props.verb;
    if (!subjectLine && !(post.actor_id === post.subject_id && post.actor_type === post.subject_type)) {
      subjectLine = (
        <span>
          {' posted on '}
          <a href={post._links.subject.href}>{post.subject_display_name}</a>
        </span>
      );
    }
    return (
      <div className="postby">
        {
          post._links.actor ? (
            <a className="postby-name" href={post._links.actor.href}>{post.actor_display_name}</a>
          ): (
            <span className="postby-name">{post.actor_display_name}</span>
          )
        }
        {' '}{subjectLine}
      </div>
    );
  }
}

export default FeedPostByline;
